import React from "react";

import { StyleSheet, View, Dimensions, ScrollView } from "react-native";

import AppMessages from "../../../../../config/AppMessages";
import { navigate } from "../../../../../helpers/utils";
import Footer from "../../../common/footer";
import ImageComponent from "../../../common/ImageComponent";
import TrackTutorialFabButton from "./TrackTutorialFabButton";
import Header from "../../../common/header";
import appStyles from "../../../../appStyles";

const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");

export default class TrackTutorialPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      isLoading: true,
      screenIndex: 1,
      mariMessage: AppMessages.TrackTutorialStep[0],
      mariAction: {
        text: "Next",
        onPress: this.toggleState,
      },
    };
  }

  toggleState = () => {
    const idx = this.state.screenIndex;
    if (idx === 4) {
      navigate(this.controller, "rn:home_card");
    } else {
      this.setState((state) => ({
        ...state,
        screenIndex: idx + 1,
        mariMessage: AppMessages.TrackTutorialStep[idx],
        mariAction: {
          text: "Next",
          onPress: this.toggleState,
        },
      }));
    }
  };

  render() {
    const { mariMessage, mariAction, screenIndex } = this.state;
    return (
      <View style={styles.container}>
        <Header
          title="Home Feed"
          avatar={this.userAvatar}
          controller={this.controller}
          hideAvatar
          returnPage="rn:home_card"
        />

        <ScrollView style={styles.scrollView}>
          <View style={{ height: "100%", alignItems: "center" }}>
            {screenIndex === 1 ? (
              <ImageComponent
                image={require("../../../../../assets/home/HomeFeed1.png")}
                styles={styles.trackBg}
              />
            ) : screenIndex === 2 ? (
              <ImageComponent
                image={require("../../../../../assets/home/HomeFeed2.png")}
                styles={styles.trackBg}
              />
            ) : screenIndex === 3 ? (
              <ImageComponent
                image={require("../../../../../assets/home/HomeFeed3.png")}
                styles={styles.trackBg}
              />
            ) : screenIndex === 4 ? (
              <ImageComponent
                image={require("../../../../../assets/home/HomeFeed4.png")}
                styles={styles.trackBg}
              />
            ) : null}
          </View>
        </ScrollView>

        <TrackTutorialFabButton
          mariOptions={{
            mariMessage: mariMessage,
            mariAction: mariAction,
          }}
        />

        {this.controller.hasNavigation() ? null : (
          <View style={styles.footerOptions}>
            <Footer controller={this.controller} selectedPage="home_card" />
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    width: WIDTH,
    height: HEIGHT,
    margin: "auto",
    ...appStyles.maxWidth,
  },
  footerOptions: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
  },
  scrollView: {
    paddingHorizontal: 10,
    maxHeight: HEIGHT - 130,
  },
  trackBg: {},
});
